var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.765,
    height: 39.118,
    viewBox: "0 0 22.765 39.118",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1387",
    "data-name": "Group 1387",
    transform: "translate(1.076 1.007)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3805",
    "data-name": "Path 3805",
    d: "M19.017,10.023A22.606,22.606,0,0,0,12.2,9a22.6,22.6,0,0,0-6.821,1.019A7.211,7.211,0,0,0,2.6,11.744C2.771,13.33,5.253,34.66,5.647,38.573a2.372,2.372,0,0,0,1.459,1.973,7.607,7.607,0,0,0,3.035.776c.34.027,1.2.1,2.055.1s1.714-.073,2.055-.1a7.6,7.6,0,0,0,3.035-.776,2.373,2.373,0,0,0,1.459-1.973c.394-3.913,2.876-25.243,3.049-26.829A7.206,7.206,0,0,0,19.017,10.023Z",
    transform: "translate(-1.854 -4.311)",
    fill: "none",
    stroke: "#fcb301",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3806",
    "data-name": "Path 3806",
    d: "M21.677,4.232a1.175,1.175,0,0,0-.489-1.079,6.659,6.659,0,0,0-1.9-1.027,21.166,21.166,0,0,0-7.084-1.12c-.284-.009-1.444-.009-1.729,0a21.166,21.166,0,0,0-7.084,1.12A6.659,6.659,0,0,0,1.5,3.153a1.254,1.254,0,0,0-.5.853",
    transform: "translate(-1 -1)",
    fill: "none",
    stroke: "#fcb301",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCup);
export default __webpack_public_path__ + "static/media/cup.bb508386b02df747b56a5b1b1e96b607.svg";
export { ForwardRef as ReactComponent };